import { styled } from '@mui/system';
import MenuItem from '@mui/material/MenuItem';
import CircularProgress from '@mui/material/CircularProgress';
import { DeleteRounded, Settings } from '@mui/icons-material';
import SpeakerNotesOutlinedIcon from '@mui/icons-material/SpeakerNotesOutlined';
import SaveRounded from '@mui/icons-material/SaveRounded';
import StopRoundedIcon from '@mui/icons-material/StopRounded';
import { getContrastColor } from '#component/theme';

const disableColor = 'rgba(0, 0, 0, 0.32)';

const iconStyles = theme => ({
  color: getContrastColor(),
  marginRight: theme.spacing()
});

const disabledIconStyles = theme => ({
  color: disableColor,
  marginRight: theme.spacing()
});

const secondaryIconStyles = theme => ({
  color: 'rgba(0, 0, 0, 0.54)',
  marginRight: theme.spacing()
});

export const StyledMenuItem = styled(MenuItem)({
  minWidth: 160
});

export const DisabledText = styled('span')({
  color: disableColor
});

export const StyledPreloader = styled(CircularProgress)(({ theme }) => ({
  color: disableColor,
  marginRight: theme.spacing(),
  marginLeft: 2
}));

export const SettingsIcon = styled(Settings)(({ theme }) => iconStyles(theme));
export const NotesIcon = styled(SpeakerNotesOutlinedIcon)(({ theme }) => iconStyles(theme));
export const SaveIcon = styled(SaveRounded)(({ theme }) => iconStyles(theme));
export const DisabledSaveIcon = styled(SaveRounded)(({ theme }) => disabledIconStyles(theme));
export const StopIcon = styled(StopRoundedIcon)(({ theme }) => secondaryIconStyles(theme));
export const DeleteIcon = styled(DeleteRounded)(({ theme }) => secondaryIconStyles(theme));
